import { defaultErrorToTerm } from '../../../otherBusinessLogic/defaultErrorToTerm';

export function errorToTerm(exception: unknown): string {
  return defaultErrorToTerm(exception) ?? 'env_pick_front_unknown_error';
}
